import axios from 'axios';
import API from '../../shared/Config/API';
import APIEndpoints from '../../shared/Config/APIEndpoints';

function getSummaryData(urls, options, params) {
  return axios.all(urls.map((url) => API.get(url, options, params))).then(
    axios.spread((res1, res2) => {
      return {
        orderSummary: res1.data,
        deliverySummary: res2.data,
      };
    })
  );
}

const fetchTargetExecution = async (queryParams) => {
  try {
    if (queryParams && queryParams?.fromDate && queryParams?.toDate) {
      return await getSummaryData(
        [APIEndpoints.GET_ORDER_SUMMARY, APIEndpoints.GET_DELIVERY_SUMMARY],
        null,
        queryParams
      );
    }
  } catch (error) {
    console.error(error);
  }
};

const getVendorOverview = async (params) => {
  return API.get(APIEndpoints.DASHBOARD_VENDOR_OVERVIEW, null, params);
};

export const executionAPI = {
  fetchTargetExecution,
  getVendorOverview,
};
